import * as dateMath from 'date-arithmetic';


export function dateSelector(){
    return new DateSpecifier();
}

class DateSpecifier{
    now(){
        return new DateModifier(new Date());
    }

    from(date:Date){
        return new DateModifier(date);
    }
}

class DateModifier{
    constructor(
        public date:Date
    ){}

    get(){
        return this.date;
    }

    addYears(interval:number){ return dateMath.add(this.date, interval, 'year'); }
    addMonths(interval:number){ return dateMath.add(this.date, interval, 'month'); }
    addDays(interval:number){ return dateMath.add(this.date, interval, 'day'); }
    addHours(interval:number){ return dateMath.add(this.date, interval, 'hours'); }
    addMins(interval:number){ return dateMath.add(this.date, interval, 'minutes'); }
    addSecs(interval:number){ return dateMath.add(this.date, interval, 'seconds'); }
    subtract(interval:number, unit:dateMath.Unit){
        return dateMath.subtract(this.date, interval, unit);
    }
}